export const CUSTOM_PERIOD = 'custom'